"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventNotificationConditionComparator = void 0;
var EventNotificationConditionComparator;
(function (EventNotificationConditionComparator) {
    EventNotificationConditionComparator["GT"] = ">";
    EventNotificationConditionComparator["GTEQ"] = ">=";
    EventNotificationConditionComparator["LT"] = "<";
    EventNotificationConditionComparator["LTEQ"] = "<=";
    EventNotificationConditionComparator["EQ"] = "=";
    EventNotificationConditionComparator["NEQ"] = "!=";
    EventNotificationConditionComparator["STARTS_WITH"] = "Starts With";
    EventNotificationConditionComparator["ENDS_WITH"] = "Ends With";
    EventNotificationConditionComparator["CONTAINS"] = "Contains";
    EventNotificationConditionComparator["NOT_EMPTY"] = "Not Empty";
})(EventNotificationConditionComparator = exports.EventNotificationConditionComparator || (exports.EventNotificationConditionComparator = {}));
